import * as B from '@blueprintjs/core';
import React from 'react';

import * as cs from './MultiFeatureAnalysis.styl';

export const MFAWidgetControls: React.FC<{
  isExpanded: boolean;
  setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  onResize?: (direction: 'minimize' | 'maximize') => void;
  onExportPng: () => void;
  onExportCsv: () => void;
}> = ({isExpanded, setIsExpanded, onResize, onExportPng, onExportCsv}) => {
  return (
    <>
      <div className={cs.widgetControlsContainer}>
        <B.Tooltip content={isExpanded ? 'Hide details' : 'Show details'}>
          <B.AnchorButton
            icon={isExpanded ? 'minimize' : 'maximize'}
            minimal
            small
            onClick={() => {
              setIsExpanded((prev) => !prev);
              onResize?.(isExpanded ? 'minimize' : 'maximize');
            }}
          />
        </B.Tooltip>
        <B.Popover
          content={
            <B.Menu>
              <B.MenuItem icon="download" text="Download chart as PNG" onClick={onExportPng} />
              <B.MenuItem icon="th" text="Download table as CSV" onClick={onExportCsv} />
            </B.Menu>
          }
          placement="bottom-end"
          minimal
        >
          <B.Button icon="more" minimal small />
        </B.Popover>
      </div>
    </>
  );
};
